import React from 'react';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import { setColumnWidth, setNumberWithComma } from '../../../../../lib/common';
import Anchor from '../../../../../components/link/Anchor';

/**
 *  기획전 아이템 리스트의 공통 컬럼
 */
export const columns = (data) => {
  return [
    {
      accessor: 'eventItemNo',
      Header: '순서',
      fixed: 'left',
      width: 50,
      Cell: (row) => data.pageNum * data.pageSize + row.index + 1,
    },
    {
      accessor: 'url',
      Header: '이미지',
      fixed: 'left',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'brandName',
      Header: '브랜드명',
      fixed: 'left',
      width: 120,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
    },
    {
      accessor: 'mainCategory',
      Header: '1차 카테고리',
      width: setColumnWidth(data.list, 'mainCategory') + 40,
    },
    {
      accessor: 'isSubCategoryExists',
      Header: '2차 카테고리',
      width: 120,
      Cell: (row) =>
        row.value ? (
          <Anchor
            text="카테고리 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              data.getProductSubCategoryList({
                productId: row.original.productId,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      accessor: 'productId',
      Header: '상품 ID',
      width: 80,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
    },
    {
      accessor: 'productName',
      Header: '상품명',
      className: 'align-left',
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      width: 200,
    },
    {
      accessor: 'originPrice',
      Header: '판매가',
      width: 80,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountPrice',
      Header: '할인가',
      width: 120,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountRate',
      Header: '할인율',
      minWidth: 120,
      Cell: (row) => setNumberWithComma(row.value, '%'),
    },
    {
      accessor: 'discountPeriod',
      Header: '할인기간',
      width: 180,
    },
    {
      accessor: 'salesPrice',
      Header: '실판매가',
      width: 120,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'createDate',
      Header: '등록일',
      width: 120,
    },
  ];
};
